import { useParams } from "wouter";
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { ArrowUturnLeftIcon, ArrowUpTrayIcon, PlusIcon, CheckCircleIcon, DocumentChartBarIcon, XCircleIcon, PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import { AuthContext } from "../contexts/auth";
import { fetchEmployee, updateDipendente, changeAppEnable } from '../services/api';
import { DynamicForm } from "../components/form/dyanmic_form";
import BackButton from "../components/back_button";
import Swal from 'sweetalert2';
import Footer from "../components/footer";
import UploadUnilavEmployee from "../components/modal_upload_unilav";
import { Tab } from '@headlessui/react';
import ContractTabEmployee from "../components/contract_tab_employee";
import RateiTabEmployee from "../components/ratei_tab_employee";
import TurnoTabEmployee from "../components/turno_tab_employee";
import AnagraficaTabEmployee from "../components/anagrafica_tab_employee";
import RuoloTabEmployee from "../components/ruolo_tab_employee";
import CheckPermissions from "../components/check_permissions";
import NoPermissions from "../authorization/NoPermissions";
import NotAuthorized from "../authorization/NotAuthorized";
import { sendCredentialEmployee } from "../services/api";

export default function EditEmployee() {
  const { profile, token } = useContext(AuthContext)
  const { codiceFiscale } = useParams();
  const searchParams = new URLSearchParams(window.location.search);

  const [fetching, setFetching] = useState(true)
  const [employee, setEmployee] = useState(null)
  const [loading, setLoading] = useState(false)
  const [showModalUploadUnilav, setShowModalUploadUnilav] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [initialValues, setInitialValues] = useState({})
  const [selectedIndex, setSelectedIndex] = useState(parseInt(searchParams.get('tab') || 0));
  const [unsavedChanges, setUnsavedChanges] = useState(false);

  const hasConsultalaHRPro = profile && profile.level && profile.level.hasOwnProperty("consultala_hr_pro");
 

  const handleToggleForm = () => {
    setShowForm(prevState => !prevState);
  };

  const fields = [
    { type: 'text', label: 'Nome', name: 'first_name', required: true },
    { type: 'text', label: 'Cognome', name: 'last_name', required: true },
    { type: 'text', label: 'Codice Fiscale', name: 'cf', disabled: true },
    { type: 'text', label: 'Email', name: 'email', required: false },
    // { type: 'checkbox', label: 'Agree to terms', name: 'terms' },
    // { type: 'select', label: 'Favorite color', name: 'color', options: ['Red', 'Green', 'Blue'] },
    // { type: 'radio', label: 'Gender', name: 'gender', options: ['Male', 'Female'] },
    // { type: 'number', label: 'Age', name: 'age' },
  ];


  const openModalUploadUnilav = () => {
    setShowModalUploadUnilav(true);
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

  useEffect(() => {
    if (token && !fetching) {
      console.log(token)
      setFetching(true)
    }
    fetchEmployee(token, codiceFiscale)
      .then((res) => {
        setEmployee(res)
        setInitialValues(res)
        setFetching(false)
      })
      .catch((err) => {
        console.log(err)
        setFetching(false)
      })
  }, [token])

  const handleSubmit = async (e, values) => {
    e.preventDefault();
    setLoading(true);
    
    // if (employee.employee.app_activate && !values.email) {
    //   Swal.fire({
    //       title: 'Attenzione!',
    //       text: 'Il dipendente ha l\'accesso attivo e non puoi eliminare l\'email. Disattiva prima l\'accesso per proseguire con l\'eliminazione.',
    //       icon: 'warning',
    //       confirmButtonText: 'OK',
    //       allowOutsideClick: false,
    //   }).then(() => {
    //       window.location.reload();
    //   });

    //   setLoading(false);
    //   return;
    // }

    try {
      let success = false;

      await updateDipendente(token, values);
  
      success = true;
      setLoading(false);
  
      Swal.fire({
        title: 'Dipendente Modificato!',
        text: 'Modifica del dipendente andata a buon fine.',
        icon: 'success',
        confirmButtonText: 'OK'
      }).then(() => {
        window.location.href = `/dipendenti/${values.cf}/edit?tab=0`;
      });
  
      setInitialValues(values);
      setUnsavedChanges(false);
  
    } catch (error) {
      setLoading(false);
      console.log(error);
      Swal.fire({
        title: 'Errore!',
        text: 'Errore durante la modifica: ' + error?.response?.data,
        icon: 'error',
        confirmButtonText: 'OK'
      }).then(() => {
        window.location.reload();
      });
  
      return;
    }
  };
  

  const handleTabChange = (index) => {
    if (index !== selectedIndex && unsavedChanges) {
      Swal.fire({
        title: 'Modifiche non salvate',
        text: "Hai delle modifiche non salvate. Cambiando tab verranno perse. Vuoi cambiare scheda?",
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'SI, continua',
        cancelButtonText: 'NO, rimani',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          setSelectedIndex(index);
          setUnsavedChanges(false);
        }
      });
    } else {
      setSelectedIndex(index);
    }
  };
  
  const handleAppStatusChange = async () => {  
    const status = employee.employee.app_activate ? 'deactivate' : 'activate';
  
    if (!employee.employee.app_activate && !employee.employee.has_active_contract) {
      const result = await Swal.fire({
        icon: 'warning',
        title: 'Attenzione<br>Contratto Attivo non presente',
        html: `Attivando l'app non sarà possibile per il dipendente effettuare l'accesso in mancanza di un contratto attivo.<br>Inserisci il contratto per abilitare l'accesso.<br>Puoi effettuare questo passaggio anche successivamente.`,
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: 'Inserisci contratto',
        denyButtonText: 'Attiva App',
        denyButtonColor: '#7066e0',
        cancelButtonText: 'Annulla',
        allowOutsideClick: false,
      });
  
      if (result.isConfirmed) {
        window.location.href = `/dipendenti/${employee.employee.cf}/edit?tab=2`;
        return;
      } else if (!result.isDenied) {
        return;
      }
    }
  
    Swal.fire({
      title: 'Attendere...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  
    try {
      await changeAppEnable(token, employee.employee.cf, status);
      setEmployee((prev) => ({
        ...prev,
        employee: {
          ...prev.employee,
          app_activate: !prev.employee.app_activate,
        },
      }));
  
      if (status === 'activate') {
        if (!employee.employee.email_auth) {
          Swal.fire({
            icon: 'success',
            title: 'App abilitata!',
            html: `L'app è stata abilitata correttamente.<br>Ricorda di salvare l'indirizzo email e di inviare le credenziali per accedere.`,
            confirmButtonText: 'OK',
            allowOutsideClick: false,
          }).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            icon: 'success',
            title: 'Salvato!',
            text: 'L\'accesso all\'app è stato attivato!',
            allowOutsideClick: false,
          }).then(() => {
            window.location.reload();
          });
        }
      } else {
        Swal.fire({
          icon: 'success',
          title: 'App disabilitata!',
          text: 'L\'accesso all\'app è stato disattivato correttamente.',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
        });
      }
    } catch (error) {
      console.error('Errore durante il salvataggio:', error);
  
      let errorMessage = 'Non è stato possibile aggiornare lo stato. Per favore riprova.';
      if (error.response && error.response.data) {
        try {
          const errorData = error.response.data;
          const errorMessages = [];
  
          if (typeof errorData === 'string') {
            errorMessage = errorData;
          } else if (typeof errorData === 'object') {
            Object.keys(errorData).forEach((key) => {
              const messageArray = errorData[key];
              if (Array.isArray(messageArray)) {
                errorMessages.push(...messageArray);
              } else if (typeof messageArray === 'string') {
                errorMessages.push(messageArray);
              }
            });
  
            if (errorMessages.length > 0) {
              errorMessage = errorMessages.join(' ');
            }
          }
        } catch (parseError) {
          console.error('Errore durante l\'estrazione del messaggio:', parseError);
        }
      }
  
      Swal.fire({
        icon: 'error',
        title: 'Errore',
        text: errorMessage,
        confirmButtonText: 'OK',
      })
    } 
  };

  const handleSendCredentials = async () => {
    if (!employee.employee.app_activate) {
      Swal.fire({
        icon: 'warning',
        title: 'Attenzione',
        text: 'Non è possibile inviare le credenziali. Prima attiva l\'accesso all\'app.',
        confirmButtonText: 'OK',
      });
      return;
    }

    if (!employee.employee.email_auth) {
      Swal.fire({
        icon: 'warning',
        title: 'Attenzione',
        text: 'Non è possibile inviare le credenziali. Prima salva l\'indirizzo email di autenticazione.',
        confirmButtonText: 'OK',
      });
      return;
    }
  
    Swal.fire({
      title: 'Invio in corso...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  
    try {
      await sendCredentialEmployee(token, employee.employee.cf);
      Swal.fire({
        icon: 'success',
        title: 'Credenziali inviate!',
        text: 'Le credenziali sono state inviate correttamente all\'email del dipendente.',
        confirmButtonText: 'OK',
      });
    } catch (error) {
      console.error('Errore durante l\'invio delle credenziali:', error);
  
      let errorMessage = 'Si è verificato un errore durante l\'invio delle credenziali. Riprova.';
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message || errorMessage;
      }
  
      Swal.fire({
        icon: 'error',
        title: 'Errore',
        text: errorMessage,
        confirmButtonText: 'OK',
      });
    }
  };
 
  return (
  <>
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow pb-8">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">

          {fetching && (
            <>
              <div
                className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <div role="status">
                  <svg className="inline w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-grey-100 fill-indigo-700" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                  </svg>
                  <span className="sr-only">Loading...</span>
                </div>
                <span className="mt-2 block text-sm font-semibold text-gray-900">Caricamento...</span>
              </div>
            </>
          )}

          {(!fetching && employee) && (
            <>
              <div className="flex items-center justify-between my-4">
                <BackButton prevLocation="/dipendenti" />

                <button 
                  className="border block rounded-md bg-grey-400 px-3 py-2 mr-2 text-center text-sm font-semibold text-grey-800 shadow-sm hover:bg-grey-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-600"
                  onClick={() => setShowModalUploadUnilav(true)}
                >
                  <ArrowUpTrayIcon className="h-4 w-4 inline-block mr-2" />
                  Aggiorna Dipendente da Unilav
                </button>
              </div>
              

              <div className="bg-white rounded-lg shadow overflow-hidden">
                <h2 className="px-4 py-3 text-lg leading-6 font-medium text-center my-4 text-indigo-800 uppercase tracking-wider">
                  Modifica Dipendente - {employee.first_name && employee.last_name ? `${employee.first_name} ${employee.last_name}` : employee.cf}
                </h2>
                <div className="bg-white rounded-lg shadow overflow-hidden">
                  {/* Dati accesso app */}
                  <Tab.Group selectedIndex={selectedIndex}>
                    <Tab.List className="flex space-x-1 rounded-xl bg-indigo-200 p-1 mx-8">
                      <Tab
                        className={({ selected }) =>
                          classNames(
                            'w-full rounded-lg py-2.5 text-sm font-medium leading-5',
                            'ring-white/60 ring-offset-2 ring-offset-indigo-800 focus:outline-none focus:ring-2',
                            selected
                              ? 'bg-white text-indigo-800 shadow uppercase'
                              : 'text-indigo-800 hover:bg-white/[0.12] hover:text-white'
                          )
                        }
                        onClick={() => handleTabChange(0)}
                      >
                        Dati Accesso App
                      </Tab>
                      <Tab
                        className={({ selected }) =>
                          classNames(
                            'w-full rounded-lg py-2.5 text-sm font-medium leading-5',
                            'ring-white/60 ring-offset-2 ring-offset-indigo-800 focus:outline-none focus:ring-2',
                            selected
                              ? 'bg-white text-indigo-800 shadow uppercase'
                              : 'text-indigo-800 hover:bg-white/[0.12] hover:text-white'
                          )
                        }
                        onClick={() => handleTabChange(1)}
                      >
                        Anagrafica
                      </Tab>
                      <Tab
                        className={({ selected }) =>
                          classNames(
                            'w-full rounded-lg py-2.5 text-sm font-medium leading-5',
                            'ring-white/60 ring-offset-2 ring-offset-indigo-800 focus:outline-none focus:ring-2',
                            selected
                              ? 'bg-white text-indigo-800 shadow uppercase'
                              : 'text-indigo-800 hover:bg-white/[0.12] hover:text-white'
                          )
                        }
                        onClick={() => handleTabChange(2)}
                      >
                        Contratto
                      </Tab>
                      <Tab
                        className={({ selected }) =>
                          classNames(
                            'w-full rounded-lg py-2.5 text-sm font-medium leading-5',
                            'ring-white/60 ring-offset-2 ring-offset-indigo-800 focus:outline-none focus:ring-2',
                            selected
                              ? 'bg-white text-indigo-800 shadow uppercase'
                              : 'text-indigo-800 hover:bg-white/[0.12] hover:text-white'
                          )
                        }
                        onClick={() => handleTabChange(3)}
                      >
                        Maturazione Ratei
                      </Tab>
                      
                      <Tab
                        className={({ selected }) =>
                          classNames(
                            'w-full rounded-lg py-2.5 text-sm font-medium leading-5',
                            'ring-white/60 ring-offset-2 ring-offset-indigo-800 focus:outline-none focus:ring-2',
                            selected
                              ? 'bg-white text-indigo-800 shadow uppercase'
                              : 'text-indigo-800 hover:bg-white/[0.12] hover:text-white'
                          )
                        }
                        onClick={() => handleTabChange(4)}
                      >
                        Turno di Lavoro
                      </Tab>

                      <Tab
                        className={({ selected }) =>
                          classNames(
                            'w-full rounded-lg py-2.5 text-sm font-medium leading-5',
                            'ring-white/60 ring-offset-2 ring-offset-indigo-800 focus:outline-none focus:ring-2',
                            selected
                              ? 'bg-white text-indigo-800 shadow uppercase'
                              : 'text-indigo-800 hover:bg-white/[0.12] hover:text-white'
                          )
                        }
                        onClick={() => handleTabChange(5)}
                      >
                        Ruolo e Autorizzazioni
                      </Tab>

                    </Tab.List>
                    <Tab.Panels className="mt-2 mx-5">
                      <Tab.Panel>
                        <div className="px-8 pt-4 flex justify-between pb-4">
                          <div className="block text-gray-700 text-sm font-bold">ACCESSO APP: <span className="font-bold text-indigo-800">{employee.employee.app_activate ? 'ATTIVO' : 'NON ATTIVO'}</span>
                          </div>
                          <div className="flex items-center space-x-2">
                              <button 
                                onClick={handleSendCredentials}
                                className="relative inline-flex items-center rounded-md bg-green-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ml-2">
                                Invia Credenziali
                              </button>
                            {employee.employee.app_activate ? 
                              (
                                <button 
                                  onClick={handleAppStatusChange}
                                  className="relative inline-flex items-center rounded-md bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ml-2">
                                  Disattiva Accesso App
                                </button>
                              ) : (
                                <button 
                                  onClick={handleAppStatusChange}
                                  className="relative inline-flex items-center rounded-md bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ml-2">
                                  Attiva Accesso App
                                </button>
                              )
                            }
                          </div>
                        </div>
                        <DynamicForm 
                          fields={fields} 
                          handleSubmit={handleSubmit} 
                          initialValues={initialValues}
                          isSaving={loading}
                          setUnsavedChanges={setUnsavedChanges}
                        />
                      </Tab.Panel>

                      <Tab.Panel> 
                        <AnagraficaTabEmployee employeeId={employee.employee.id} setUnsavedChanges={setUnsavedChanges} />
                      </Tab.Panel>
          
                      <Tab.Panel> 
                          <ContractTabEmployee employeeId={employee.employee.id} setUnsavedChanges={setUnsavedChanges} />
                      </Tab.Panel>

                      <Tab.Panel>
                        {hasConsultalaHRPro ? (
                          <RateiTabEmployee employeeId={employee.employee.id} setUnsavedChanges={setUnsavedChanges} />
                        ) : (
                          <NotAuthorized />
                        )}
                      </Tab.Panel>

                      <Tab.Panel>
                        {hasConsultalaHRPro ? (
                          <CheckPermissions 
                            permissionsToCheck={[
                              'hr.view_shifts_ou', 
                              'hr.view_shifts_all', 
                              'hr.manage_shifts_ou', 
                              'hr.manage_shifts_all'
                            ]}
                          >
                            <TurnoTabEmployee 
                              employeeId={employee.employee.id} 
                              setUnsavedChanges={setUnsavedChanges} 
                              employee={
                                (employee.employee.last_name && employee.employee.first_name) 
                                  ? `${employee.employee.last_name} ${employee.employee.first_name}`
                                  : employee.employee.cf
                              }
                              employeeEmailAuth={employee.employee.email_auth}
                              onTabContractChange={(index) => handleTabChange(index)} 
                            />
                          </CheckPermissions>
                        ) : (
                          <NotAuthorized />
                        )}
                      </Tab.Panel>
                      <Tab.Panel>
                        {profile.customer_type !== 'employee' ? (
                          hasConsultalaHRPro ? (
                            <RuoloTabEmployee employeeId={employee.employee.id} />
                          ) : (
                            <NotAuthorized />
                          )
                        ) : (
                          <NoPermissions />
                        )}
                      </Tab.Panel>
                    </Tab.Panels>
                  </Tab.Group>
                </div>
              </div>
            </>
          )}
        </div>
      </main >
      <Footer />
      {showModalUploadUnilav && (
        <UploadUnilavEmployee closeModalUploadUnilav={() => setShowModalUploadUnilav(false)}/>
      )}
    </div>
  </>);

  };
  